import script from "./BaseCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=4bab6da1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bab6da1"]])

export default __exports__